var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadlight3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 141,
    viewBox: "0 0 209 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 209,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 159,
    height: 46,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.373 40.047H102.409V49H101.079V41.622C100.846 41.7573 100.608 41.8623 100.365 41.937C100.122 42.007 99.8797 42.0467 99.637 42.056V40.768C99.9403 40.7307 100.234 40.656 100.519 40.544C100.808 40.4273 101.093 40.2617 101.373 40.047Z",
    fill: "#004552"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 75,
    width: 49.1399,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 75,
    width: 49.1399,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 75,
    width: 49.1399,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2393 102V100.593C43.2393 100.084 43.3186 99.6573 43.4773 99.312C43.6359 98.962 43.8669 98.6703 44.1703 98.437C44.4736 98.2037 44.8423 98.003 45.2763 97.835L47.0683 97.135C47.4976 96.9623 47.8173 96.743 48.0273 96.477C48.2373 96.211 48.3423 95.882 48.3423 95.49C48.3423 95.084 48.1999 94.748 47.9153 94.482C47.6306 94.216 47.2269 94.083 46.7043 94.083C46.1956 94.083 45.7733 94.1997 45.4373 94.433C45.1059 94.6617 44.9169 95.0047 44.8703 95.462H43.3933C43.4166 94.9067 43.5706 94.44 43.8553 94.062C44.1399 93.684 44.5249 93.3993 45.0103 93.208C45.4956 93.0167 46.0533 92.921 46.6833 92.921C47.2713 92.921 47.7986 93.033 48.2653 93.257C48.7319 93.481 49.1006 93.7913 49.3713 94.188C49.6466 94.5847 49.7843 95.042 49.7843 95.56C49.7843 96.022 49.7003 96.4257 49.5323 96.771C49.3643 97.1117 49.1169 97.408 48.7903 97.66C48.4636 97.912 48.0669 98.1313 47.6003 98.318L45.7803 99.039C45.3696 99.1977 45.0639 99.3843 44.8633 99.599C44.6673 99.809 44.5693 100.084 44.5693 100.425V100.775H49.7143V102H43.2393Z",
    fill: "#004552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.531 102.182C101.074 102.182 100.633 102.119 100.208 101.993C99.7837 101.862 99.4011 101.676 99.0604 101.433C98.7244 101.186 98.4584 100.88 98.2624 100.516C98.0664 100.147 97.9684 99.7227 97.9684 99.242H99.3544C99.3684 99.606 99.4711 99.9163 99.6624 100.173C99.8537 100.43 100.11 100.626 100.432 100.761C100.754 100.892 101.121 100.957 101.531 100.957C102.147 100.957 102.626 100.81 102.966 100.516C103.312 100.222 103.484 99.8533 103.484 99.41C103.484 99.1253 103.412 98.8757 103.267 98.661C103.127 98.4463 102.906 98.2807 102.602 98.164C102.304 98.0427 101.914 97.982 101.433 97.982H100.348V96.932H101.174C101.79 96.932 102.276 96.806 102.63 96.554C102.985 96.2973 103.162 95.9497 103.162 95.511C103.162 95.119 103.015 94.79 102.721 94.524C102.427 94.258 102 94.125 101.44 94.125C100.997 94.125 100.603 94.216 100.257 94.398C99.9121 94.5753 99.6834 94.895 99.5714 95.357H98.1924C98.2624 94.7783 98.4444 94.3093 98.7384 93.95C99.0324 93.5907 99.4081 93.3293 99.8654 93.166C100.323 93.0027 100.834 92.921 101.398 92.921C102.01 92.921 102.556 93.026 103.036 93.236C103.522 93.4413 103.902 93.7283 104.177 94.097C104.453 94.4657 104.59 94.8903 104.59 95.371C104.59 95.833 104.46 96.232 104.198 96.568C103.942 96.8993 103.566 97.1537 103.071 97.331C103.622 97.499 104.07 97.7673 104.415 98.136C104.761 98.5 104.933 98.962 104.933 99.522C104.933 100.04 104.793 100.5 104.513 100.901C104.233 101.302 103.839 101.617 103.33 101.846C102.822 102.07 102.222 102.182 101.531 102.182Z",
    fill: "#004552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.443 92.97H158.71V98.78H160.257V99.914H158.71V102H157.394V99.914H152.823V98.899L157.443 92.97ZM157.45 95L154.398 98.899H157.45V95Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlight3);
export default __webpack_public_path__ + "static/media/headlight-3.2bacd59bd6a457823f4eb14fed17457f.svg";
export { ForwardRef as ReactComponent };